var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.svg#icon-btn_radio';
                    var viewUrl = 'sprites.svg#view-icon-btn_radio';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 32 32',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };